import i18n from '~/i18n';

interface Day {
  id: number;
  name: string;
  displayName: string;
  type: string;
}

export const getDays = () => {
  const t = i18n.t;
  return [
    { id: 0, name: t('monday'), displayName: 'Monday', type: 'monday' },
    { id: 1, name: t('tuesday'), displayName: 'Tuesday', type: 'tuesday' },
    {
      id: 2,
      name: t('wednesday'),
      displayName: 'Wednesday',
      type: 'wednesday',
    },
    { id: 3, name: t('thursday'), displayName: 'Thursday', type: 'thursday' },
    { id: 4, name: t('friday'), displayName: 'Friday', type: 'friday' },
    { id: 5, name: t('saturday'), displayName: 'Saturday', type: 'saturday' },
    { id: 6, name: t('sunday'), displayName: 'Sunday', type: 'sunday' },
  ] as Day[];
};
